const rawBase = (process.env.REACT_APP_MAGENTO_BASE_URL || '').trim();
const sanitizedBase = rawBase.replace(/\/+$/, '');

export const MAGENTO_BASE_URL = sanitizedBase;

const isAbsoluteUrl = (value = '') => /^https?:\/\//i.test(value);

export const buildApiUrl = (path = '') => {
  if (!path) return sanitizedBase;
  if (isAbsoluteUrl(path)) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (!sanitizedBase) return normalizedPath;
  return `${sanitizedBase}${normalizedPath}`;
};

export const apiFetch = (input, init) => {
  if (typeof input === 'string') {
    return fetch(buildApiUrl(input), init);
  }
  return fetch(input, init);
};
